export const STORES = [
  {
    storeNumber: 1,
    location: 1001,
    name: 'DALLAS - DOWNTOWN',
    line1: '1618 MAIN ST',
    city: 'DALLAS',
    county: 'DALLAS',
    state: 'TX',
    country: 'US',
    zip: '75201',
    storeId: '01/DT',
    phoneNumber1: '214-741-6911',
    phoneNumber2: '800-937-9146',
    timeZone: 'America/Chicago',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 6PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 6PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 6PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Sun',
        hours: ['11AM - 5PM'],
      },
    ],
  },
  {
    storeNumber: 2,
    location: 1002,
    name: 'DALLAS - NORTHPARK',
    line1: '8687 N CENTRAL EXPY STE 400',
    city: 'DALLAS',
    county: 'DALLAS',
    state: 'TX',
    country: 'US',
    zip: '75225',
    storeId: '02/NP',
    phoneNumber1: '214-363-8311',
    phoneNumber2: '800-756-5784',
    timeZone: 'America/Chicago',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 9PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 9PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 7PM'],
      },
    ],
  },
  {
    storeNumber: 3,
    location: 1003,
    name: 'FORT WORTH',
    line1: '5200 MONAHANS AVE',
    city: 'FORT WORTH',
    county: 'TARRANT',
    state: 'TX',
    country: 'US',
    zip: '76109',
    storeId: '03/FW',
    phoneNumber1: '817-738-3581',
    phoneNumber2: '800-234-0788',
    timeZone: 'America/Chicago',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 4,
    location: 1004,
    name: 'HOUSTON - GALLERIA',
    line1: '2600 POST OAK BLVD',
    city: 'HOUSTON',
    county: 'HARRIS',
    state: 'TX',
    country: 'US',
    zip: '77056',
    storeId: '04/HO',
    phoneNumber1: '713-621-7100',
    phoneNumber2: '800-397-5293',
    timeZone: 'America/Chicago',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 9PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 5,
    location: 1005,
    name: 'BAL HARBOUR',
    line1: '9700 COLLINS AVE',
    city: 'BAL HARBOUR',
    county: 'MIAMI-DADE',
    state: 'FL',
    country: 'US',
    zip: '33154',
    storeId: '05/BH',
    phoneNumber1: '305-865-6161',
    phoneNumber2: '888-884-6136',
    timeZone: 'America/New_York',
    workingHours: [
      {
        label: 'Mon',
        hours: ['11AM - 9PM'],
      },
      {
        label: 'Tue',
        hours: ['11AM - 9PM'],
      },
      {
        label: 'Wed',
        hours: ['11AM - 9PM'],
      },
      {
        label: 'Thu',
        hours: ['11AM - 9PM'],
      },
      {
        label: 'Fri',
        hours: ['11AM - 9PM'],
      },
      {
        label: 'Sat',
        hours: ['11AM - 9PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 7PM'],
      },
    ],
  },
  {
    storeNumber: 6,
    location: 1006,
    name: 'ATLANTA',
    line1: '3393 PEACHTREE RD NE',
    city: 'ATLANTA',
    county: 'FULTON',
    state: 'GA',
    country: 'US',
    zip: '30326',
    storeId: '06/AT',
    phoneNumber1: '404-266-8200',
    phoneNumber2: '800-555-5077',
    timeZone: 'America/New_York',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 9PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 7,
    location: 1007,
    name: 'ST. LOUIS',
    line1: '100 PLAZA FRONTENAC ST',
    city: 'SAINT LOUIS',
    county: 'SAINT LOUIS',
    state: 'MO',
    country: 'US',
    zip: '63131',
    storeId: '07/SL',
    phoneNumber1: '314-567-9811',
    phoneNumber2: '877-634-6260',
    timeZone: 'America/Chicago',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 9,
    location: 1009,
    name: 'CHICAGO - NORTHBROOK',
    line1: '5000 NORTHBROOK CT',
    city: 'NORTHBROOK',
    county: 'COOK',
    state: 'IL',
    country: 'US',
    zip: '60062',
    storeId: '09/NB',
    phoneNumber1: '847-564-0300',
    phoneNumber2: '800-323-5684',
    timeZone: 'America/Chicago',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 10,
    location: 1010,
    name: 'BEVERLY HILLS',
    line1: '9700 WILSHIRE BLVD',
    city: 'BEVERLY HILLS',
    county: 'LOS ANGELES',
    state: 'CA',
    country: 'US',
    zip: '90212',
    storeId: '10/LA',
    phoneNumber1: '310-550-5900',
    phoneNumber2: '877-634-6263',
    timeZone: 'America/Los_Angeles',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 11,
    location: 1011,
    name: 'NEWPORT BEACH - FASHION ISLAND',
    line1: '601 NEWPORT CENTER DR',
    city: 'NEWPORT BEACH',
    county: 'ORANGE',
    state: 'CA',
    country: 'US',
    zip: '92660',
    storeId: '11/FI',
    phoneNumber1: '949-759-1900',
    phoneNumber2: '800-395-1036',
    timeZone: 'America/Los_Angeles',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Sun',
        hours: ['11AM - 7PM'],
      },
    ],
  },
  {
    storeNumber: 12,
    location: 1012,
    name: 'SAN FRANCISCO',
    line1: '150 STOCKTON ST',
    city: 'SAN FRANCISCO',
    county: 'SAN FRANCISCO',
    state: 'CA',
    country: 'US',
    zip: '94108',
    storeId: '12/SF',
    phoneNumber1: '415-362-3900',
    phoneNumber2: '877-634-6264',
    timeZone: 'America/Los_Angeles',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 6PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 6PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 6PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Sun',
        hours: ['11AM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 13,
    location: 1013,
    name: 'DALLAS - WILLOW BEND',
    line1: '2201 DALLAS PKWY',
    city: 'PLANO',
    county: 'COLLIN',
    state: 'TX',
    country: 'US',
    zip: '75093',
    storeId: '13/PWB',
    phoneNumber1: '972-629-1700',
    phoneNumber2: '877-634-6265',
    timeZone: 'America/Chicago',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 14,
    location: 1014,
    name: 'WESTCHESTER',
    line1: '2 E MAPLE AVE',
    city: 'WHITE PLAINS',
    county: 'WESTCHESTER',
    state: 'NY',
    country: 'US',
    zip: '10601',
    storeId: '14/WC',
    phoneNumber1: '914-428-2000',
    phoneNumber2: '877-634-6269',
    timeZone: 'America/New_York',
    workingHours: [
      {
        label: 'Mon',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Tue',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Wed',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Thu',
        hours: ['11AM - 8PM'],
      },
      {
        label: 'Fri',
        hours: ['11AM - 8PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 15,
    location: 1015,
    name: 'LAS VEGAS',
    line1: '3200 LAS VEGAS BLVD S',
    city: 'LAS VEGAS',
    county: 'CLARK',
    state: 'NV',
    country: 'US',
    zip: '89109',
    storeId: '15/LV',
    phoneNumber1: '702-731-3636',
    phoneNumber2: '800-288-7741',
    timeZone: 'America/Los_Angeles',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 6PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 6PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 6PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 6PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 6PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 6PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 16,
    location: 1016,
    name: 'SAN DIEGO',
    line1: '7027 FRIARS RD',
    city: 'SAN DIEGO',
    county: 'SAN DIEGO',
    state: 'CA',
    country: 'US',
    zip: '92108',
    storeId: '16/SD',
    phoneNumber1: '619-692-9100',
    phoneNumber2: '800-200-0522',
    timeZone: 'America/Los_Angeles',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Sun',
        hours: ['11AM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 17,
    location: 1017,
    name: 'CHICAGO - OAKBROOK',
    line1: '6 OAKBROOK CTR',
    city: 'OAK BROOK',
    county: 'DUPAGE',
    state: 'IL',
    country: 'US',
    zip: '60523',
    storeId: '17/OB',
    phoneNumber1: '630-572-1500',
    phoneNumber2: '877-868-2966',
    timeZone: 'America/Chicago',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 5PM'],
      },
    ],
  },
  {
    storeNumber: 19,
    location: 1019,
    name: 'CHICAGO - MICHIGAN AVENUE',
    line1: '737 N MICHIGAN AVE',
    city: 'CHICAGO',
    county: 'COOK',
    state: 'IL',
    country: 'US',
    zip: '60611',
    storeId: '19/MA',
    phoneNumber1: '312-642-5900',
    phoneNumber2: '800-642-4480',
    timeZone: 'America/Chicago',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 20,
    location: 1020,
    name: 'BOSTON',
    line1: '5 COPLEY PL',
    city: 'BOSTON',
    state: 'MA',
    country: 'US',
    zip: '02116',
    storeId: '20/BN',
    phoneNumber1: '617-536-3660',
    phoneNumber2: '877-563-4626',
    county: 'SUFFOLK',
    timeZone: 'America/New_York',
    workingHours: [
      {
        label: 'Mon',
        hours: ['11AM - 8PM'],
      },
      {
        label: 'Tue',
        hours: ['11AM - 8PM'],
      },
      {
        label: 'Wed',
        hours: ['11AM - 8PM'],
      },
      {
        label: 'Thu',
        hours: ['11AM - 8PM'],
      },
      {
        label: 'Fri',
        hours: ['11AM - 8PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 23,
    location: 1023,
    name: 'TYSONS GALLERIA',
    line1: '2255 INTERNATIONAL DR',
    city: 'MC LEAN',
    county: 'FAIRFAX',
    state: 'VA',
    country: 'US',
    zip: '22102',
    storeId: '23/TY',
    phoneNumber1: '703-761-1600',
    phoneNumber2: '877-877-1849',
    timeZone: 'America/New_York',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 9PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 24,
    location: 1024,
    name: 'PALO ALTO',
    line1: '400 STANFORD SHOPPING CTR',
    city: 'PALO ALTO',
    county: 'SANTA CLARA',
    state: 'CA',
    country: 'US',
    zip: '94304',
    storeId: '24/PA',
    phoneNumber1: '650-329-3300',
    phoneNumber2: '877-877-3907',
    timeZone: 'America/Los_Angeles',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Sun',
        hours: ['11AM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 25,
    location: 1025,
    name: 'SHORT HILLS',
    line1: '1200 MORRIS TPKE',
    city: 'SHORT HILLS',
    county: 'ESSEX',
    state: 'NJ',
    country: 'US',
    zip: '07078',
    storeId: '25/SH',
    phoneNumber1: '973-912-0080',
    phoneNumber2: '877-777-5321',
    timeZone: 'America/New_York',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sun',
        hours: ['11AM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 27,
    location: 1027,
    name: 'DENVER',
    line1: '3030 E 1ST AVE',
    city: 'DENVER',
    county: 'DENVER',
    state: 'CO',
    country: 'US',
    zip: '80206',
    storeId: '27/DN',
    phoneNumber1: '303-329-2600',
    phoneNumber2: '877-777-5324',
    timeZone: 'America/Denver',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 6PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 6PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 6PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 6PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Sun',
        hours: ['11AM - 7PM'],
      },
    ],
  },
  {
    storeNumber: 28,
    location: 1028,
    name: 'PARAMUS',
    line1: '503 GARDEN STATE PLZ',
    city: 'PARAMUS',
    county: 'BERGEN',
    state: 'NJ',
    country: 'US',
    zip: '07652',
    storeId: '28/PR',
    phoneNumber1: '201-291-1920',
    phoneNumber2: '877-868-3169',
    timeZone: 'America/New_York',
    workingHours: [
      {
        label: 'Mon',
        hours: ['11AM - 9PM'],
      },
      {
        label: 'Tue',
        hours: ['11AM - 9PM'],
      },
      {
        label: 'Wed',
        hours: ['11AM - 9PM'],
      },
      {
        label: 'Thu',
        hours: ['11AM - 9PM'],
      },
      {
        label: 'Fri',
        hours: ['11AM - 9PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 9PM'],
      },
      {
        label: 'Sun',
        hours: ['CLOSED'],
      },
    ],
  },
  {
    storeNumber: 29,
    location: 1029,
    name: 'SCOTTSDALE',
    line1: '6900 E CAMELBACK RD',
    city: 'SCOTTSDALE',
    county: 'MARICOPA',
    state: 'AZ',
    country: 'US',
    zip: '85251',
    storeId: '29/SC',
    phoneNumber1: '480-990-2100',
    phoneNumber2: '800-937-6379',
    timeZone: 'America/Denver',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 5PM'],
      },
    ],
  },
  {
    storeNumber: 30,
    location: 1030,
    name: 'KING OF PRUSSIA',
    line1: '170 N GULPH RD',
    city: 'KING OF PRUSSIA',
    county: 'MONTGOMERY',
    state: 'PA',
    country: 'US',
    zip: '19406',
    storeId: '30/KP',
    phoneNumber1: '610-962-6200',
    phoneNumber2: '800-456-5501',
    timeZone: 'America/New_York',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 9PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 31,
    location: 1031,
    name: 'HONOLULU - ALA MOANA',
    line1: '1450 ALA MOANA BLVD',
    city: 'HONOLULU',
    county: 'HONOLULU',
    state: 'HI',
    country: 'US',
    zip: '96814',
    storeId: '31/AM',
    phoneNumber1: '808-951-8887',
    phoneNumber2: '877-951-8887',
    timeZone: 'Pacific/Honolulu',
    workingHours: [
      {
        label: 'Mon',
        hours: ['11AM - 6PM'],
      },
      {
        label: 'Tue',
        hours: ['11AM - 6PM'],
      },
      {
        label: 'Wed',
        hours: ['11AM - 6PM'],
      },
      {
        label: 'Thu',
        hours: ['11AM - 6PM'],
      },
      {
        label: 'Fri',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Sat',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 33,
    location: 1033,
    name: 'TROY',
    line1: '2705 W BIG BEAVER RD',
    city: 'TROY',
    county: 'OAKLAND',
    state: 'MI',
    country: 'US',
    zip: '48084',
    storeId: '33/TR',
    phoneNumber1: '248-643-3300',
    phoneNumber2: '800-937-6488',
    timeZone: 'America/New_York',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 9PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 34,
    location: 1034,
    name: 'CORAL GABLES',
    line1: '390 SAN LORENZO AVE',
    city: 'CORAL GABLES',
    county: 'MIAMI-DADE',
    state: 'FL',
    country: 'US',
    zip: '33146',
    storeId: '34/CG',
    phoneNumber1: '786-999-1000',
    phoneNumber2: '800-794-9374',
    timeZone: 'America/New_York',
    workingHours: [
      {
        label: 'Mon',
        hours: ['11AM - 9PM'],
      },
      {
        label: 'Tue',
        hours: ['11AM - 9PM'],
      },
      {
        label: 'Wed',
        hours: ['11AM - 9PM'],
      },
      {
        label: 'Thu',
        hours: ['11AM - 9PM'],
      },
      {
        label: 'Fri',
        hours: ['11AM - 9PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 9PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 35,
    location: 1035,
    name: 'TAMPA BAY',
    line1: '2223 N WEST SHORE BLVD',
    city: 'TAMPA',
    county: 'HILLSBOROUGH',
    state: 'FL',
    country: 'US',
    zip: '33607',
    storeId: '35/TB',
    phoneNumber1: '813-877-5700',
    phoneNumber2: '800-388-5646',
    timeZone: 'America/New_York',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 36,
    location: 1036,
    name: 'ORLANDO',
    line1: '4170 CONROY RD',
    city: 'ORLANDO',
    county: 'ORANGE',
    state: 'FL',
    country: 'US',
    zip: '32839',
    storeId: '36/OR',
    phoneNumber1: '407-264-5900',
    phoneNumber2: '800-590-7046',
    timeZone: 'America/New_York',
    workingHours: [
      {
        label: 'Mon',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Tue',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Wed',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Thu',
        hours: ['11AM - 8PM'],
      },
      {
        label: 'Fri',
        hours: ['11AM - 8PM'],
      },
      {
        label: 'Sat',
        hours: ['11AM - 8PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 7PM'],
      },
    ],
  },
  {
    storeNumber: 37,
    location: 1037,
    name: 'SAN ANTONIO',
    line1: '15900 LA CANTERA PKWY',
    city: 'SAN ANTONIO',
    county: 'BEXAR',
    state: 'TX',
    country: 'US',
    zip: '78256',
    storeId: '37/SA',
    phoneNumber1: '210-558-8000',
    phoneNumber2: '866-328-5475',
    timeZone: 'America/Chicago',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 9PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 9PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 9PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 9PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 9PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 9PM'],
      },
      {
        label: 'Sun',
        hours: ['11PM - 7PM'],
      },
    ],
  },
  {
    storeNumber: 38,
    location: 1038,
    name: 'BOCA RATON',
    line1: '5860 GLADES RD',
    city: 'BOCA RATON',
    county: 'PALM BEACH',
    state: 'FL',
    country: 'US',
    zip: '33431',
    storeId: '38/BR',
    phoneNumber1: '561-417-5151',
    phoneNumber2: '800-680-9039',
    timeZone: 'America/New_York',
    workingHours: [
      {
        label: 'Mon',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Tue',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Wed',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Thu',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Fri',
        hours: ['11AM - 8PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 63,
    location: 1063,
    name: "BERGDORF GOODMAN WOMEN'S STORE",
    line1: '754 5TH AVE',
    city: 'NEW YORK',
    county: 'NEW YORK',
    state: 'NY',
    country: 'US',
    zip: '10019',
    storeId: '63/NY',
    phoneNumber1: '212-753-7300',
    phoneNumber2: '',
    timeZone: 'America/New_York',
    workingHours: [
      {
        label: 'Mon',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Tue',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Wed',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Thu',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Fri',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Sat',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Sun',
        hours: ['11AM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 64,
    location: 1064,
    name: "BERGDORF GOODMAN MEN'S STORE",
    line1: '745 5TH AVE',
    city: 'NEW YORK',
    county: 'NEW YORK',
    state: 'NY',
    country: 'US',
    zip: '10151',
    storeId: '64/NY',
    phoneNumber1: '212-753-7300',
    phoneNumber2: '',
    timeZone: 'America/New_York',
    workingHours: [
      {
        label: 'Mon',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Tue',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Wed',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Thu',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Fri',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Sat',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Sun',
        hours: ['11AM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 101,
    location: 1101,
    name: 'AUSTIN',
    line1: '3400 PALM WAY',
    city: 'AUSTIN',
    county: 'TRAVIS',
    state: 'TX',
    country: 'US',
    zip: '78758',
    storeId: '101/AN',
    phoneNumber1: '866-880-1293',
    phoneNumber2: '',
    timeZone: 'America/Chicago',
    workingHours: [
      {
        label: 'Mon',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Tue',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Wed',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Thu',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 102,
    location: 1102,
    name: 'CHARLOTTE',
    line1: '4400 SHARON RD',
    city: 'CHARLOTTE',
    county: 'MECKLENBURG',
    state: 'NC',
    country: 'US',
    zip: '28211',
    storeId: '102/CH',
    phoneNumber1: '704-442-7900',
    phoneNumber2: '800-353-8755',
    timeZone: 'America/New_York',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 103,
    location: 1103,
    name: 'NATICK',
    line1: '310 SPEEN ST',
    city: 'NATICK',
    county: 'MIDDLESEX',
    state: 'MA',
    country: 'US',
    zip: '01760',
    storeId: '103/NA',
    phoneNumber1: '508-620-5700',
    phoneNumber2: '866-773-6176',
    timeZone: 'America/New_York',
    workingHours: [
      {
        label: 'Mon',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Tue',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Wed',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Thu',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Fri',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Sat',
        hours: ['11AM - 7PM'],
      },
      {
        label: 'Sun',
        hours: ['12PM - 6PM'],
      },
    ],
  },
  {
    storeNumber: 105,
    location: 1105,
    name: 'TOPANGA',
    line1: '6550 TOPANGA CANYON BLVD',
    city: 'WOODLAND HILLS',
    county: 'LOS ANGELES',
    state: 'CA',
    country: 'US',
    zip: '91303',
    storeId: '105/TP',
    phoneNumber1: '818-316-7000',
    phoneNumber2: '888-664-8404',
    timeZone: 'America/Los_Angeles',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Sun',
        hours: ['11PM - 7PM'],
      },
    ],
  },
  {
    storeNumber: 111,
    location: 1111,
    name: 'ROOSEVELT FIELD',
    line1: '620 OLD COUNTRY ROAD',
    city: 'GARDEN CITY',
    county: 'NASSAU',
    state: 'NY',
    country: 'US',
    zip: '11530',
    storeId: '111/RF',
    phoneNumber1: '516-368-0500',
    phoneNumber2: '',
    timeZone: 'America/New_York',
    workingHours: [
      {
        label: 'Mon',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Tue',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Wed',
        hours: ['10AM - 7PM'],
      },
      {
        label: 'Thu',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Fri',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sat',
        hours: ['10AM - 8PM'],
      },
      {
        label: 'Sun',
        hours: ['11PM - 7PM'],
      },
    ],
  },
];

export const STORE_HOURS = new Map(
  STORES.map((store) => {
    const { storeNumber, timeZone, workingHours } = store;
    return [Number(storeNumber), { timeZone, workingHours }];
  }),
);
